export default __webpack_public_path__ + "static/media/pagination-green__active.8f254b32.svg";